import React from 'react'

const starPath = (
  <path d="M13.6673 5.73264C13.734 5.39931 13.4673 4.99931 13.134 4.99931L9.33398 4.46597L7.60065 0.999308C7.53398 0.865975 7.46732 0.799308 7.33398 0.732641C7.00065 0.532641 6.60065 0.665975 6.40065 0.999308L4.73398 4.46597L0.933984 4.99931C0.733984 4.99931 0.600651 5.06597 0.533984 5.19931C0.267318 5.46597 0.267318 5.86597 0.533984 6.13264L3.26732 8.79931L2.60065 12.5993C2.60065 12.7326 2.60065 12.866 2.66732 12.9993C2.86732 13.3326 3.26732 13.466 3.60065 13.266L7.00065 11.466L10.4007 13.266C10.4673 13.3326 10.6007 13.3326 10.734 13.3326C10.8007 13.3326 10.8007 13.3326 10.8673 13.3326C11.2007 13.266 11.4673 12.9326 11.4007 12.5326L10.734 8.73264L13.4673 6.06597C13.6007 5.99931 13.6673 5.86598 13.6673 5.73264Z" />
)

export const Star = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {starPath}
    </svg>
  )
}

export const StarGold = (props: React.SVGProps<SVGSVGElement>) => {
  const fillColour = 'rgb(255, 203, 70)'
  return <Star fill={fillColour} {...props} />
}
export const StarOrange = (props: React.SVGProps<SVGSVGElement>) => {
  const fillColour = '#EF8D29'
  return <Star fill={fillColour} {...props} />
}
